import React from "react";
import {Grid, MenuItem, Select, SelectChangeEvent} from "@mui/material";
import {Controller, useFormContext} from "react-hook-form";

interface MWSelectBoxProps<T> {
  name: string;
  label: string;
  onChange?: (event: SelectChangeEvent<number>) => void;
  data: T[];
}

const MWSelectBox = <
  T extends {
    uid?: number | undefined;
    name?: string | undefined;
    categoryName?: string | undefined;
    itemName?: string | undefined;
  }
>({
  name,
  label,
  data,
  onChange,
}: MWSelectBoxProps<T>) => {
  const {control} = useFormContext();

  return (
    <Controller
      name={name}
      control={control}
      render={({field}) => (
        <Grid container alignItems="center" justifyContent="flex-start">
          <Grid
            item
            xs={0}
            sm={0}
            md={3}
            lg={3}
            xl={3}
            sx={{display: {xs: "none", sm: "none", md: "block"}}}
          >
            <label htmlFor={name}>{label} : </label>
          </Grid>

          <Grid item xs={12} sm={12} md={5} lg={5} xl={5}>
            <Select
              {...field}
              id={name}
              size="small"
              defaultValue={field.value}
              style={{width: "100%"}}
              onChange={onChange ?? field.onChange}
            >
              <MenuItem disabled value={field.value} style={{display: "none"}}>
                선택하세요
              </MenuItem>
              {data !== undefined &&
                data?.map((item) => (
                  <MenuItem key={item.uid} value={item.uid}>
                    {item.name ?? item.categoryName ?? item.itemName ?? ""}
                  </MenuItem>
                ))}
            </Select>
          </Grid>
        </Grid>
      )}
    />
  );
};

export default MWSelectBox;
